import { SearchField } from '@rematter/ui-web';

import * as state from '../../_state/bookingList.state';

import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

export const BookingListFilterBar = () => {
  const [search, setSearch] = useDebouncedAtom(state.$searchParam, 300);

  return (
    <div className="@BookingListFilterBar flex items-center gap-2">
      <SearchField
        autoFocus
        placeholder="Search bookings"
        aria-label="Search bookings"
        value={search}
        className="h-[34px] w-[250px] [&>div]:h-full"
        onChange={(value) => setSearch(value ?? '')}
      />
    </div>
  );
};
